module.exports = __webpack_public_path__ + "static/media/capa-home-1024.9a6f2c92.jpg";